import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

import './PortfolioSection.css';

/* ---------- Afbeeldingen ---------- */
import website1 from '../../images/website1.png';
import website2 from '../../images/website2.png';
import website3 from '../../images/website3.png';
import moodboard1 from '../../images/moodbord1.png';
import moodboard2 from '../../images/moodbord2.png';
import moodboard3 from '../../images/moodbord3.png';
import moodboard4 from '../../images/moodbord4.png';

/* ---------- Websites ---------- */
const websites = [
  {
    title: 'David Coffa',
    img: website1,
    url: 'https://davidcoffa.nl',
  },
  {
    title: 'BouwWonders',
    img: website2,
    url: 'https://bouwwonders.nl',
  },
  {
    title: 'Kortingsmaatje',
    img: website3,
    url: 'https://kortingsmaatje.nl',
  },
];

/* ---------- Instagram moodboard (lokaal) ---------- */
const instaPosts = [
  { img: moodboard1, url: 'https://instagram.com/p/0001' },
  { img: moodboard2, url: 'https://instagram.com/p/0002' },
  { img: moodboard3, url: 'https://instagram.com/p/0003' },
  { img: moodboard4, url: 'https://instagram.com/p/0003' },
];

export default function PortfolioSection() {
  return (
    <section className="portfolio-section py-5">
      <div className="container">
        {/* -------- Kop -------- */}
        <header className="text-center mb-5">
          <h2 className="portfolio-title">Portfolio</h2>
          <p className="portfolio-subtitle">
            Een greep uit ons werk – websites &amp; social creaties
          </p>
        </header>

        {/* -------- Websites grid -------- */}
        <h3 className="subheading mb-4">Websites</h3>
        <div className="row gy-4 gx-lg-4 mb-5">
          {websites.map(({ title, img, url }, idx) => (
            <div key={idx} className="col-12 col-md-6 col-lg-4">
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="portfolio-card shadow-sm d-block"
              >
                <img src={img} alt={title} className="img-fluid" loading="lazy" />
                <div className="card-overlay">
                  <span className="card-title">{title}</span>
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-2" />
                </div>
              </a>
            </div>
          ))}
        </div>

        {/* -------- Instagram moodboard -------- */}
        <h3 className="subheading mb-4">Instagram moodboard</h3>
        <div className="row gy-4 gx-lg-4">
          {instaPosts.map(({ img, url }, idx) => (
            <div key={idx} className="col-6 col-md-3">
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="insta-card d-block shadow-sm"
              >
                <img src={img} alt="Instagram post" className="img-fluid" loading="lazy" />
                <div className="insta-overlay">
                  <FontAwesomeIcon icon={faInstagram} size="lg" />
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
